import { ListItem as ListItem2, ListItemButton, ListItemText, Typography } from '@mui/material'
import React from 'react'

export const ListItem = ({
  index,
  selectedIndex,
  onClick,
  icon,
  label,
  disabled
}: {
  index: number
  selectedIndex: number
  onClick: (index: number) => void
  icon: React.ReactNode
  label: string
  disabled?: boolean
}) => (
  <ListItem2 sx={{ px: 0 }}>
    <ListItemButton
      disabled={disabled}
      sx={{
        borderRadius: '8px',
        backgroundColor: selectedIndex === index ? '#EEF2F5 !important' : 'transparent',
        '&:hover': { backgroundColor: '#EEF2F5' },
      }}
      selected={selectedIndex === index}
      onClick={() => onClick(index)}
    >
      {icon}
      <ListItemText
        primary={
          <Typography ml={1} fontSize="0.875rem" color="primary.dark">
            {label}
          </Typography>
        }
      />
    </ListItemButton>
  </ListItem2>
)
